function initDeferAnimation() {
	const deferredBlocks = [...document.querySelectorAll('[data-defer]')];

	deferredBlocks.forEach((block) => {
		const blockInner = block.children;

		gsap.set(blockInner, { y: 30, scale: 0.99, autoAlpha: 0 })
	})

	const deferInstances = ScrollTrigger.batch(deferredBlocks, {
		start: 'top 85%',
		end: 'bottom 25%',
		onToggle: (blocks) => {
			const children = [];
			blocks.forEach((block) => {
				children.push(...block.children);
			});

			gsap.to(children, {
				y: 0,
				scale: 1,
				autoAlpha: 1,
				duration: 0.48,
				stagger: 0.12,
			});
		}
	});
}
